import { NgModule } from '@angular/core';
import { BasePipelineModule } from '../pipe-base/pipe-base.module';
import { PipeObligationCardComponent } from './pipe-obligation-card/pipe-obligation-card.component';
import { PipeObligationComponent } from './pipe-obligation.component';

@NgModule({
  imports: [
    BasePipelineModule,    
  ],
  declarations: [
    PipeObligationComponent, PipeObligationCardComponent
  ],
  exports: [
    PipeObligationComponent, PipeObligationCardComponent
  ]
})

export class pipeObligationModule { }
